import Swiper from "swiper/bundle";

export const initSwiper = () => {
    const homeCategoriesSlider = new Swiper(".home-categories-slider", {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
            540: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            720: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            960: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            1320: {
                slidesPerView: 6,
                spaceBetween: 20,
            },
            1560: {
                slidesPerView: 6,
                spaceBetween: 40,
            }
        }

    });

    const homeImageSlider = new Swiper(".home-image-slider", {
        loop: true,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    const suppliersSlider = new Swiper(".suppliers-slider", {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        slidesPerView: 2,
        spaceBetween: 10,

        breakpoints: {
            540: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            720: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            960: {
                slidesPerView: 6,
                spaceBetween: 20,
            },
            1320: {
                slidesPerView: 8,
                spaceBetween: 20,
            }
        }
    });

    const relatedProductsSlider = new Swiper(".related-products-slider", {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
            540: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            720: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            960: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1160: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1320: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
        }

    });
}